import { browser } from "$app/environment";
import { waitLocale } from "svelte-i18n";
import { i18nClientInit } from "$lib/i18n/i18n";
import type { Load } from "@sveltejs/kit";
import type { BannersQuery, GetNavQuery } from "$lib/gql/genCms/codegen";
import { GetNavDoc, BannersDoc } from "$lib/gql/genCms/codegen";
import client from "$lib/gql/apolloClient";
import { clientIp } from "$lib/stores/clientIp";

export const load: Load = async ({ data }) => {
  // state should not be set here, particularly during SSR
  // (https://kit.svelte.dev/docs/state-management#avoid-shared-state-on-the-server)
  if (browser) {
    i18nClientInit(data.session.userPrefs);
  }

  if (data?.session?.clientIP) {
    clientIp.set(data?.session.clientIP);
  }

  await waitLocale();

  const navQuery = await client.query<GetNavQuery>({
    query: GetNavDoc,
    variables: {
      id: "main",
    },
    context: {
      clientName: "cms",
      clientIP: data?.session.clientIP,
      preview: data?.preview,
    },
  });

  const bannerQuery = await client.query<BannersQuery>({
    query: BannersDoc,
    context: {
      clientName: "cms",
      clientIP: data?.session.clientIP,
      preview: data?.preview,
    },
  });

  return {
    navData: navQuery,
    bannerData: bannerQuery,
    session: data?.session,
    locale: data?.locale,
    preview: data?.preview,
  };
};
